// patrones
export const regex_dec = /^[0-9]*\.?[0-9]*$/; // acepta números decimales / precios
export const regex_num = /^[0-9\b]+$/; // acepta números
export const regex_no_num = /^([^0-9]*)$/; // NO acepta números
export const regex_phone = /^(?!(\d{2,})\1+)(?!(\d+)\2{3,})(\+\d{1,3})?(\d{9,10})$/;
// correos electrónicos
export const regex_email = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
// obtener extensión de archivo
export const regex_file_ext = /(?:\.([^.]+))?$/;

// reconocer problemas en consulta de backend
export const match1 = /Duplicate entry '.*?' for key '.*?'/;
export const match2 = /Table '\S+\.\S+' doesn't exist/;
export const match3 = /Unknown column '.*?' in '.*?'/;
export const match4 = /Unknown database '.*?'/;
export const match5 = /Cannot add or update a child row: a foreign key constraint fails.*/;
export const match6 = /You have an error in your SQL syntax;.*/;
export const match7 = /Can't connect to MySQL server on '.*?'/;
export const match8 = /Cannot delete or update a parent row: a foreign key constraint fails.*/;
export const match9 = /Data truncated for column '.*?'/;
export const match10 = /Out of range value for column '.*?'/;
export const match11 = /Column '.*?' cannot be null/;
// No database selected